import { AlertsService } from "approot/global/providers/uikit.alerts";
import { IdentityProvider, LoginRepository } from "./login.repository";
import { LoginData, LoginDataService } from "./services/login.data.service";
import { LoginStrategiesService } from "./services/login.strategies.service";
import { SsoChooseRoleService } from "./services/sso-choose-role.service";
import { AccountInfo } from "./sessionstore";
import { ChangeLanguageService } from "./services/changeLanguage.service";

class AccountsLoginController {
	private mobile: boolean;
	private mobileAccessToken: string;
	private loginState: string;

	public accounts: AccountInfo[];
	public ready: boolean;
	public silentAuth: boolean = false
	public accessToken: string | null

	/*@ngInject*/
	constructor(
		private loginDataService: LoginDataService,
		private loginStrategiesService: LoginStrategiesService,
		private ssoChooseRoleService: SsoChooseRoleService,
		private loginRepository: LoginRepository,
		private $location: ng.ILocationService,
		private $q: ng.IQService,
		private $alerts: AlertsService,
		private changeLanguageService: ChangeLanguageService,
		public language: any
	) {
		this.init();
	}

	private async init() {
		await this.changeLanguageService.pageLanguageLoaded;

		let searchParams = new URLSearchParams(window.location.search);
		this.mobile = searchParams.has('mobile');
		if (this.mobile) {
			this.mobileAccessToken = searchParams.get('access_token');
		}

		this.silentAuth = searchParams.has('silent');

		if (this.silentAuth && this.isHaveAccessToken()) {
			const account = this.loginDataService.loginData.accounts.find(acc => acc.accessToken && acc.accessToken.trim() !== '');
			this.accessToken = account.accessToken;

			(<any>account).logsIn = true;
			this.$location.path("/authorize/accountlogin").search(this.collectParams());

			return
		}

		this.load();
	}

	isHaveAccessToken (): boolean {
		return this.loginDataService.loginData.accounts.some(acc => !!acc.accessToken);
	}

	private load() {
		const promises = [];
		const authContextReady = this.authContextStore();
		promises.push(authContextReady);
		const loginDataReady = this.loginDataService.load();
		promises.push(loginDataReady);

		this.$q.all(promises)
			.then(() => {
				this.onReady();
			});
	}

	private authContextStore() {
		if (this.mobile) {
			let formCollection: any = { mobile: "1" };
			if (this.mobileAccessToken) {
				formCollection.mobileAccessToken = this.mobileAccessToken;
			}
			return this.loginRepository.createLoginState(formCollection).then((loginState) => {
				this.loginState = loginState;
			});
		}
		return Promise.resolve();
	}

	private onReady() {
		let loginData: LoginData = this.loginDataService.loginData;
		this.accounts = loginData.accounts;
		let loginOptions = loginData.loginOptions;
		if (this.loginState) {
			loginOptions.loginState = this.loginState;
		}
		// сброс признака - логинится
		this.accounts.forEach(account => (<any>account).logsIn = false);
		this.ready = true;
	}

	firstLetter(account: AccountInfo): string {
		return account.user.name?.charAt(0).toUpperCase();
	}

	canEsia(): boolean {
		return this.loginDataService.loginData.viewData?.esiaLogin;
	}

	loginWithEsia() {
		this.ssoChooseRoleService.execute(IdentityProvider.Esia);
	}

	canEsa(): boolean {
		return this.loginDataService.loginData.viewData?.esaLogin;
	}

	loginWithEsa() {
		this.ssoChooseRoleService.execute(IdentityProvider.Esa);
	}

	private collectParams() {
		let params: any = {};

		if (this.mobile) {
			params.mobile = "1";
		}

		// не вложенный if, так как в инициализации вложен
		if (this.mobileAccessToken) {
			params.access_token = this.mobileAccessToken;
		}

		let queryLanguage = ChangeLanguageService.getQueryLanguage();
		if (queryLanguage != null) {
			params.lang = queryLanguage;
		}

		return params;
	}

	login(back?: boolean) {
		let searchParams = this.collectParams();
		if (back) {
			searchParams.back = "1";
		}

		this.$location.path("/authorize/login").search(searchParams);
	}

	accountLogin(account: AccountInfo) {
		if (account.organizations.length == 0) {
			this.$alerts.error(`${this.language.Generic.Common.kUser} ${account.user.name} ${this.language.Generic.Login.kNotMemberAnyOO}`);
			this.removeAccount(account);
		} else {
			// логинится
			(<any>account).logsIn = true;
			this.$location.path("/authorize/accountlogin").search(this.collectParams());
		}
	}

	removeAccount(account: AccountInfo) {
		this.loginDataService.removeAccount(account);

		if (!this.loginDataService.hasAccounts()) {
			this.login();
		}
	}
}

export const AccountsLoginComponent = {
	templateUrl: "/static/dist/app/login/accounts.login.component.html",
	controllerAs: "$ctrl",
	controller: AccountsLoginController
}